module.exports = __webpack_public_path__ + "static/img/arrows.cdb3e938.png";